import request from '@/util/request';

// 获取物料类型树状列表
export const getGoodsTypeTreeApi = (params, options) =>
  request.get(
    '/api/v4ward/warehouse/consumable/type/lazyTree',
    Object.assign({}, options, { params })
  );

// 获取物料列表
export const getGoodsListApi = (params, options) =>
  request.get('/api/v4ward/warehouse/consumable/list', Object.assign({}, options, { params }));

// 根据入库单获取物料列表
export const getGoodsListByInIdApi = (params, options) =>
  request.get(
    '/api/v4ward/warehouse/inbound/consumable/getConsumableListByInboundId',
    Object.assign({}, options, { params })
  );
